import React, { useState, useContext } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { UserContext } from './UserContext';
import apiFetch from '../utils/apiFetch';

const ReferralForm = ({ jobId, jobTitle, companyName, hrName, round, showAlert }) => {
  const { user } = useContext(UserContext);
  
  const [referalName, setReferalName] = useState("");
  const [referalNumber, setReferalNumber] = useState("");
  const [referalGender, setReferalGender] = useState("male");

  const checkduplicate = async (name, mobile, gender) => {
    if (!mobile || mobile.length < 10) { 
      showAlert("Mobile number length is below 10 digits!", "error"); 
      return false; 
    }
    
    const phone = mobile.toString().replace(/-/g, '').slice(-10);
    const apiURL = `${process.env.REACT_APP_API_URL}/applicants/phone/${phone}`;
    
    try {
      const res = await apiFetch(apiURL, { method: "GET" });
      const data = res.status === 200 ? await res.json() : await res.text();
      
      if (data?.data) {
        showAlert(`${data.data.name} registered with ${data.data.mobile} already!`, "info");
        setReferalName(""); setReferalNumber(""); setReferalGender("male");
        return false;
      } else {
        addApplicant(name, mobile, gender); 
        return true;
      }
    } catch (err) {
      showAlert("96" + String(err), "error"); 
      return false;
    }
  };

  const addApplicant = (name, mobile, gender) => {
    let apiURL = process.env.REACT_APP_API_URL + "/applicants/addapplicant";
    let apiParams = {
      method: "POST",
      headers: {
        name, mobile, gender, jobid: jobId, jobtitle: jobTitle,
        companyname: companyName && companyName.split(" - ")[0],
        reference: encodeURIComponent("Candidate Referal: " + name + " - " + mobile),
        createdbyid: user._id, createdbyname: user.name, authtoken: localStorage.getItem("loggedintoken")
      }
    };
    
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) applyJob(repos.data); 
        else showAlert("102" + (repos.message || repos), "error");
      })
      .catch((err) => showAlert(('43' + err), "error"));
  };

  const applyJob = (applicant) => {
    let apiURL = process.env.REACT_APP_API_URL + "/interview/applyinterview/" + applicant._id;
    let apiParams = {
      method: "POST",
      headers: {
        hrname: hrName, name: applicant.name, mobile: applicant.mobile, jobid: jobId, jobtitle: jobTitle,
        companyname: companyName && companyName.split(" - ")[0], round: round, interviewername: hrName,
        createdbyid: user._id, createdbyname: user.name,
        reference: encodeURIComponent("Candidate Referal: " + referalName + " - " + referalNumber),
        authtoken: localStorage.getItem("loggedintoken")
      },
    };
    
    apiFetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
          setReferalName(""); setReferalNumber(""); setReferalGender("male");
          showAlert("Referral added Sucessfully!", "success");
        }
      })
      .catch((err) => showAlert(('98' + err), "error"));
  };

  const handleAdd = () => {
    if(!jobId || !companyName) {
      showAlert("Please select a Job and Company first.", "error");
      return;
    }
    checkduplicate(referalName, referalNumber, referalGender);
  };

  return (
    <>
      <div className='Refer_Name_txt'>
        <TextField sx={{ width: "125px", marginTop: "2px" }} id="Refer_Name_txt" size="small" label="Refer Name" variant="outlined" value={referalName} onChange={(e) => { setReferalName(e.target.value) }} />
      </div>
      
      <div className='Refer_Mobile_txt'>
        <TextField sx={{ width: "125px", marginTop: "2px" }} id="Refer_Mobile_txt" size="small" label="Refer Mobile" variant="outlined" value={referalNumber} onChange={(e) => { setReferalNumber(e.target.value) }} />
      </div>

      <div className='Candidate_Gender_txt'>
        <FormControl variant="outlined" sx={{ width: 125, marginTop: "2px" }} size="small"  >
          <InputLabel id="demo-Candidate_Gender_txt-select-label"  >Gender</InputLabel>
          <Select labelId="demo-simple-select-labell" id="Candidate_Gender_txt" value={referalGender} onChange={(e) => { setReferalGender(e.target.value); }} >
            <MenuItem value="male">Male</MenuItem><MenuItem value="female">Female</MenuItem><MenuItem value="others">Others</MenuItem>
          </Select>
        </FormControl>
      </div>

      <div className="Add_Referal_Candidate">
        <input type="button" style={{ width: "30px", height: "45px" }} onClick={handleAdd} value="+" />
      </div>
    </>
  );
};

export default ReferralForm;